<template>
    <layout>
        <div class="p-2 bg-light_yellow">
            <div class="container mx-auto mt-6">
                <h1 class="px-4 mb-10 text-xl font-bold align-middle my-9 text-enriqueto_green"><span class="inline-block align-middle rounded-full w-9 h-9 type" :class="classification.type"></span>{{classification.name}} </h1>
                <p class=" w-96">
                    {{classification.description}}
                </p>
            </div>
        </div>
        <div class="container pt-6 mx-auto">
            <FruitCollectionPaginated :list="fruits" />
        </div>
    </layout>    
</template>

<script>
import FruitColletion from '../../Components/Fruit/FruitColletion.vue'
import Layout from '../../Components/Shared/Layout.vue'
import FruitCollectionPaginated from '../../Components/Fruit/FruitCollectionPaginated.vue'

export default {
    components: {Layout,FruitColletion,FruitCollectionPaginated},
    props: ['classification','fruits'],
    setup(props){
        console.log(props.fruits);
    }
}
</script>

<style lang='scss'>
    .type{
        margin-right: 20px;
        &.VITA{
            background-color: #C65EEB;
        }
        &.DOMINIO{
            background-color: #77C3FF;
        }
        &.REINO{
            background-color: #77FFF9;
        }
        &.DIVISIÓN{
            background-color: #77FFB6;
        }
        &.CLASE{
            background-color: #7BFF77;
        }
        &.ORDEN{
            background-color: #BEFF77;
        }
        &.FAMILIA{
            background-color: #FFFD77;
        }
        &.GENERO{
            background-color: #FFBA77;
        }
        &.ESPECIE{
            background-color: #EBAE85;
        }
        &:hover{
            transform: scale(1.1);
        }
    }
</style>